import React from "react"
import { encode } from 'querystring';
import logo from "../../assets/images/logo-forest.png";
import logoRight from "../../assets/images/logo-right.png";
import profilelogo from "../../assets/images/profile-img.jpg";
import lng from "../../assets/images/lng.png";
import { useNavigate } from 'react-router-dom';
import EventBus from "../../utilities/EventBus";
import { useSelector } from "react-redux";
import { GetDictionary } from '../../utilities/CommonFunctions';
import { GetOnlineHelpToken } from '../../services/end-url';
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import CommonService from "../../services/common.service";
const UserHeader = () => {
    const [dic_lng, setdic_lng] = useState({});
    const location = useLocation();
    const { user: currentUser } = useSelector((state) => state.auth);
    const isgisuser = currentUser?.is_gisuser ?? false;
    function navigateURL(component) {
        window.location.href = globalThis.config.Settings.ApiConfiguration.Appurl;
    }

    var loginuser_name = '';
    const logOut = async () => {
        EventBus.dispatch("logout");
        // navigate("/");
        navigate(location.pathname.includes('/as')) ? navigateURL("/as") : navigateURL("/");
    }
    useEffect(() => {
        async function callfunc() {
            let d = await GetDictionary("1,3,4,31");
            setdic_lng(d);
        }
        callfunc();

    }, [])
    const { i18n } = useTranslation();


    useEffect(() => {
        if (location.pathname.includes('/as')) {
            i18n.changeLanguage("as");
            globalThis.config.Settings.Locale = 'as';
            document.getElementById("langSwitcher").innerHTML = "English"
        }
        else {
            i18n.changeLanguage("en");
            globalThis.config.Settings.Locale = 'en';
            document.getElementById("langSwitcher").innerHTML = "অসমীয়া"
        }
    }, [])

    const switchLanguage = async () => {
        if (location.pathname.includes('/as')) {
            i18n.changeLanguage("as");
            globalThis.config.Settings.Locale = 'as';
            document.getElementById("langSwitcher").innerHTML = "English"
            let d = await GetDictionary("1,2,3,4,5,6,7,8,9");
            setdic_lng(d);
            window.location.href = window.location.href.replace('/as', '');
        }
        else {
            i18n.changeLanguage("en");
            globalThis.config.Settings.Locale = 'en';
            document.getElementById("langSwitcher").innerHTML = "অসমীয়া"
            let d = await GetDictionary("1,2,3,4,5,6,7,8,9");
            setdic_lng(d);
            window.location.href = window.location.href + "/as";
        }

    }

    const redirectToFMIS = async () => {
        const queryParams = encode({
            userName: currentUser.userName,
            passwordHash: currentUser.passwordHash
        });
        const url = globalThis.config.Settings.ApiConfiguration.SSO_urls.FMIS;
        const state = encodeURIComponent(JSON.stringify({ body: queryParams }));
        const finalUrl = `${url}?state=${state}`;
        window.open(finalUrl, '_blank');
    };
    const redirectToGIS = async () => {
        const queryParams = encode({
            userName: currentUser.userName,
            passwordHash: currentUser.passwordHash
        });
        const url = globalThis.config.Settings.ApiConfiguration.SSO_urls.GIS;
        const state = encodeURIComponent(JSON.stringify({ body: queryParams }));
        const finalUrl = `${url}?state=${state}`;
        window.open(finalUrl, '_blank');
    };

    const { user } = useSelector((state) => state.auth)
    if (user && user.userName) {
        let result = user.emailId != null ? user.emailId.split('@') : [''];
        loginuser_name = result[0];
    }
    document.querySelectorAll('.navbar-collapse .nav-link').forEach(function (link) {
        link.addEventListener('click', function () {
            const navbarCollapse = document.querySelector('.navbar-collapse');
            if (navbarCollapse.classList.contains('show')) {
                new bootstrap.Collapse(navbarCollapse).hide();
            }
        });
    });
    const openHelp = () => {
        try {
            CommonService.getAll(GetOnlineHelpToken)
                .then(response => {
                    window.open(globalThis.config.Settings.ApiConfiguration.HelpURL + "?token=" + response.data[0].token + "&lang=" + globalThis.config.Settings.Locale, '_blank'); // Open in new tab
                }
                )
        }
        catch (ex) {
            console.log(ex);
        }
    }
    const navigate = useNavigate();
    return (
        <>
            <div className="container-fluid ">
                <div className=" py-1 border-bottom top-header px-2 d-none">
                    <div className="container-fluid d-flex flex-wrap ">
                        <div className="col-5 col-lg-auto mb-2 mb-lg-0 me-lg-auto acceessibility">
                            <div className="textcontrols">
                                <button role="button" id="decreasetext">
                                    <span> A- </span>
                                </button>
                                <button role="button" id="resettext">
                                    <span>A</span>
                                </button>
                                <button role="button" id="increasetext">
                                    <span>A+</span>
                                </button>
                            </div>
                        </div>
                        <div className="text-end justify-content-flex-end">
                            <a href=" " className="btn btn-light text-dark  btn-sm justify-content-flex-end" >
                            </a>
                        </div>
                    </div>
                </div>
                <header id="header" className="header fixed-top d-flex align-items-center" style={{ top: "0px" }}>
                    <div className="d-flex align-items-center justify-content-between" onClick={() => (location.pathname.includes('/as')) ? navigateURL("/as") : navigateURL("/")}>
                        <a className="d-flex align-items-center my-2 my-lg-0   text-decoration-none">
                            <img src={logo} className="logo logo-mobile" />
                            <span className="px-3 logo-text">
                                <small className='d-none d-lg-block'>   {dic_lng["HeaderTitle1_PMIS"]}</small>
                                <span className='d-none d-lg-block'>  {dic_lng["PMIS"]}
                                </span>
                                <span className='d-lg-none d-sm-block'>  PMIS
                                </span>
                            </span>
                        </a>
                        <i className="bi bi-list toggle-sidebar-btn d-none" />
                    </div>
                    {/* End Logo */}
                    <div className="search-bar">
                        <form className="search-form d-flex align-items-center" method="POST" action="#">
                            <input type="text" name="query" placeholder="Search" title="Enter search keyword" />
                            <button type="submit" title="Search">
                                <i className="bi bi-search" />
                            </button>
                        </form>
                    </div>
                    {/* End Search Bar */}
                    <nav className="header-nav ms-auto " >
                        <ul className="d-flex align-items-center">
                            <li class="nav-item ">
                                <a id="" href="javascript:void(0)" class="btn btn-light text-dark  btn-sm"

                                    onClick={openHelp}>
                                    <i class="bi bi-question-circle"></i> <span class="d-none"> Help </span></a></li>
                            <li className="nav-item dropdown ">

                                <div className="dropdown">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-success dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                    >
                                        {dic_lng["go_to"]} &nbsp;
                                    </button>
                                    <ul className="dropdown-menu bg-success text-white">
                                        {isgisuser === "True" ?
                                            <>
                                                <li><a id="Geoexplorer"
                                                    onClick={redirectToGIS}
                                                    className="dropdown-item text-white"> {dic_lng["GeoXplorer"]}
                                                </a></li>

                                                <li>
                                                    <hr className="dropdown-divider" />
                                                </li>
                                            </>
                                            : ""}
                                        <li>
                                            <a
                                                className="dropdown-item text-white"
                                                id="FMIS"
                                                onClick={redirectToFMIS}
                                            >
                                                <span>{dic_lng["FMIS"]}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li className="nav-item ">
                                <a href={void (0)} className="btn btn-light text-dark btn-sm" onClick={switchLanguage} ><img className="lng" src={lng} /><span id="langSwitcher"></span></a>
                            </li>
                            {/* End Search Icon*/}
                            <li className="nav-item dropdown d-none">
                                <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
                                    <i className="bi bi-bell" />
                                    <span className="badge bg-primary badge-number">4</span>
                                </a>
                                {/* End Notification Icon */}
                                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
                                    <li className="dropdown-header">
                                        Today's Notifications (4)
                                        <a href="#">
                                            <span className="badge rounded-pill bg-primary p-2 ms-2">
                                                View all
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="notification-item">
                                        <i className="bi bi-exclamation-circle text-warning" />
                                        <div>
                                            <h4>Tree outside forest</h4>
                                            <p>
                                                New Registration for Plantation on Non-Forest Land is Received
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="notification-item">
                                        <i className="bi bi-x-circle text-danger" />
                                        <div>
                                            <h4>Offence Record</h4>
                                            <p>New Offence reported for minor mineral.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="notification-item">
                                        <i className="bi bi-check-circle text-success" />
                                        <div>
                                            <h4>Ex-Gratia</h4>
                                            <p>Crop damange claim received.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="notification-item">
                                        <i className="bi bi-info-circle text-primary" />
                                        <div>
                                            <h4>Encroachment</h4>
                                            <p>New encroachment reported.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="dropdown-footer">
                                        <a href="#">Show all notifications</a>
                                    </li>
                                </ul>
                                {/* End Notification Dropdown Items */}
                            </li>
                            {/* End Notification Nav */}
                            <li className="nav-item dropdown d-none">
                                <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
                                    <i className="bi bi-chat-left-text" />
                                    <span className="badge bg-success badge-number">3</span>
                                </a>
                                {/* End Messages Icon */}
                                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages">
                                    <li className="dropdown-header">
                                        You have 3 new messages
                                        <a href="#">
                                            <span className="badge rounded-pill bg-primary p-2 ms-2">
                                                View all
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="message-item">
                                        <a href="#">
                                            <img src=" assets/img/messages-1.jpg" alt="" className="rounded-circle" />
                                            <div>
                                                <h4>Maria Hudson</h4>
                                                <p>
                                                    Velit asperiores et ducimus soluta repudiandae labore
                                                    officia est ut...
                                                </p>
                                                <p>4 hrs. ago</p>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="message-item">
                                        <a href="#">
                                            <img
                                                src=" assets/img/messages-2.jpg"
                                                alt=""
                                                className="rounded-circle"
                                            />
                                            <div>
                                                <h4>Anna Nelson</h4>
                                                <p>
                                                    Velit asperiores et ducimus soluta repudiandae labore
                                                    officia est ut...
                                                </p>
                                                <p>6 hrs. ago</p>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="message-item">
                                        <a href="#">
                                            <img src=" assets/img/messages-3.jpg" alt="" className="rounded-circle" />
                                            <div>
                                                <h4>David Muldon</h4>
                                                <p>
                                                    Velit asperiores et ducimus soluta repudiandae labore
                                                    officia est ut...
                                                </p>
                                                <p>8 hrs. ago</p>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="dropdown-footer">
                                        <a href="#">Show all messages</a>
                                    </li>
                                </ul>
                                {/* End Messages Dropdown Items */}
                            </li>
                            {/* End Messages Nav */}
                            <li className="nav-item dropdown border-right-0">
                                {user ? (
                                    <div className="nav-link nav-profile d-flex align-items-center pe-0"
                                        data-bs-toggle="dropdown">
                                        <img src={profilelogo}
                                            alt="Profile"
                                            className="rounded-circle profilelogo"
                                        />
                                        <span className="d-none d-md-block dropdown-toggle ps-2">{loginuser_name}</span>
                                    </div>
                                ) : <></>}

                                {/* End Profile Iamge Icon */}
                                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                                    <li>
                                        <a className="dropdown-item d-flex align-items-center" href={globalThis.config.Settings.Locale == 'en' ? globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserProfile"
                                            : globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserProfile/as"}>
                                            <i className="bi bi-person" />
                                            <span>My Profile</span>
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li>
                                        <a className="dropdown-item d-flex align-items-center" href="users-profile.html" >
                                            <i className="bi bi-gear" />
                                            <span>Account Settings</span>
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)" className="dropdown-item d-flex align-items-center"
                                            onClick={openHelp}
                                        >
                                            <i className="bi bi-question-circle" />
                                            <span>Help</span>
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li>
                                        <a className="dropdown-item d-flex align-items-center" onClick={logOut}>
                                            <i className="bi bi-box-arrow-right" />
                                            <span>Sign Out</span>
                                        </a>
                                    </li>
                                </ul>
                                {/* End Profile Dropdown Items */}
                            </li>
                            {/* End Profile Nav */}
                            <li>
                                <a href={void (0)} className="btn-book-a-table">
                                    {" "}
                                    <img src={logoRight} className="logoRight" />
                                </a>
                            </li>
                        </ul>
                    </nav>
                    {/* End Icons Navigation */}
                </header>
                {/* End Header */}
            </div>
        </>
    )
}
export default UserHeader;